// extracted by mini-css-extract-plugin
export var fullHeightState = "_4k-7";
export var headerCell = "_4k-1";
export var loadingStateCell = "_4k-4";
export var rowWrapper = "_4k-3";
export var standaloneTable = "_4k-8";
export var standaloneTableWithBodyFill = "_4k-9";
export var stateCell = "_4k-5";
export var table = "_4k-0";
export var tableBodyFiller = "_4k-6";
export var white = "_4k-2";